<template>
  <div>
    <label v-if="label" :for="id" class="input__label">{{ label }}</label>
    <input
      :id="id"
      :name="id"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      @blur="emit('blur', $event.target.value)"
      @keyup.enter.exact="emit('enter', $event.target.value)"
      @change="emit('change', $event.target.value)"
      @input="emit('input', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  name: 'Input',
  props: {
    label: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: this.$uuid.v1().replace(/-/g, ''),
    }
  },
  methods: {
    emit(event, value) {
      if (this.type === 'number') value = parseInt(value, 10)
      this.$emit(event, value)
    },
  },
}
</script>

<style lang="scss" scoped>
input {
  width: 100%;
  height: 32px;
  object-fit: contain;
  border-radius: 2px;
  border: solid 1px #ddd;
  background-color: #fff;
  padding: 5px;
  &:disabled {
    cursor: not-allowed;
  }
}

.input__label {
  font-weight: 700;
}
</style>
